import {Pipe, PipeTransform} from '@angular/core';
import {timeToStringHHMM} from '../../../utils/date';

@Pipe({
	name: "time",
})
export class TimePipe implements PipeTransform {
	transform(value: any, args?: any): any {
    if(value && typeof value === 'string' )
         return value;

	 return timeToStringHHMM(value) || "--:--:--";

	}
}
